const routes = [
    {
        name: 'listarCertificadosClientesParceiro',
        path: '/parceiro/certificados_digitais',
        alias: [
            '/parceiro/certificados_digitais/index',
            '/contabilidade/certificados_digitais',
            '/contabilidade/certificados_digitais/index',
        ],
        component: () => import('../views/Listar'),
    },
]

export default routes
